import type {LazyFeatureFlagId} from '../feature-flag.types';
import {useFeatureFlagApi} from './useFeatureFlagApi';

export async function useLazyFeatureFlag(flagId: LazyFeatureFlagId) {
    const {fetchFeatureFlag} = useFeatureFlagApi();

    return fetchFeatureFlag(flagId);
}
